import * as React from 'react';

import './BusView.scss';
import { Bus, CardEvent } from 'src/store/events/types';
import ParticipantsList from '../ParticipantsList/ParticipantsList';
import { connect } from 'react-redux';
import { hideBus, showBus } from 'src/store/bus/action';
import { IconPaths } from 'src/icons';
import { User } from 'src/store/user/types';

interface Props {
  event: CardEvent;
  buses: Bus[];
  user: User;
  hideBus: typeof hideBus;
  showBus: typeof showBus;
}

interface State {
  selectedBusIndex: number;
}

class BusView extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedBusIndex: 0
    };

    this.onChange = this.onChange.bind(this);
  }

  onHide = (busId: number) => {
    this.props.hideBus(busId);
  };

  onShow = (busId: number) => {
    this.props.showBus(busId);
  };

  public render() {
    const { buses, event } = this.props;
    const { selectedBusIndex } = this.state;
    return (
      <React.Fragment>
        <div className={'busViewContainer ' + (buses[selectedBusIndex].hidden ? 'busHidden' : '')}>
          {this.renderBusHeader(
            buses.length,
            selectedBusIndex,
            selectedBusIndex + 1 < buses.length,
            selectedBusIndex > 0
          )}
          <ParticipantsList event={event} participations={buses[selectedBusIndex].participants} />
        </div>
      </React.Fragment>
    );
  }

  onChange(type: string) {
    console.log(this.state.selectedBusIndex);
    if (type === 'fwd') {
      this.setState({ selectedBusIndex: this.state.selectedBusIndex + 1 });
    } else if (type === 'bkwd') {
      this.setState({ selectedBusIndex: this.state.selectedBusIndex - 1 });
    }
  }

  renderBusHeader = (busLength: number, index: number, forward: boolean, backwards: boolean) => {
    const bus = this.props.buses[index];
    return (
      <div className="busViewHeader">
        <div className="busInfo">
          {bus && bus.quota > 0 && (
            <div>
              Kontingent: <span>{bus.quota} Personen</span>
            </div>
          )}
          <div>
            Teilnehmer:{' '}
            {bus.participants ? (
              bus.bookedBy !== undefined && <span>{bus.participants.length} Personen</span>
            ) : (
              <span>0 Personen</span>
            )}
          </div>
          {bus.quota > 0 && bus.quota < 1000 && (
            <div>
              Freie Plätze:{' '}
              {bus.participants && bus.bookedBy !== undefined && (
                <span>{bus.quota - bus.bookedBy} Personen</span>
              )}
            </div>
          )}
        </div>
        <span className="busTitle">
          <h3>{`Bus ${index + 1}`}</h3>
        </span>
        {this.props.user.role.canUpdateEvents && (
          <div style={{ display: 'inline-block', marginLeft: '10px' }}>
            {bus.hidden ? (
              <span className="pointer" onClick={this.onShow.bind(this, bus.id)}>
                <img src={IconPaths['show-icon']} title="Einblenden" height="25px" />
              </span>
            ) : (
              <span className="pointer" onClick={this.onHide.bind(this, bus.id)}>
                <img src={IconPaths['hide-icon']} title="Ausblenden" height="25px" />
              </span>
            )}
          </div>
        )}
        <div className="busViewControls">
          <span style={{ fontWeight: 500 }}>
            Bus {index + 1}/{busLength}
          </span>
          <span
            className={backwards ? '' : 'disabled'}
            onClick={() => {
              if (backwards) {
                this.onChange('bkwd');
              }
            }}
          >
            &lt;
          </span>
          <span
            className={forward ? '' : 'disabled'}
            onClick={() => {
              if (forward) {
                this.onChange('fwd');
              }
            }}
          >
            &gt;
          </span>
        </div>
      </div>
    );
  };
}

const mapDispatchToProps = (dispatch: any) => ({
  hideBus: (busId: number) => dispatch(hideBus(busId)),
  showBus: (busId: number) => dispatch(showBus(busId))
});

export default connect(
  null,
  mapDispatchToProps
)(BusView);



// WEBPACK FOOTER //
// ./src/pages/Event/EventDetail/BusView/BusView.tsx